import {ApiSortsDerived} from '@/api/meta/odata';
import {getDetailContactHistoryEmail} from '@/api/module/contactHistory';
import {createVersionedStorage} from './types';
import {
  ApiContactHistoryEmail,
  ContactHistoryEmail,
  DetailContactHistoryEmailFilters,
} from '@/model/ContactHistoryEmail';

export type DetailContactHistoryEmailStore = ReturnType<typeof useDetailContactHistoryEmailStore>;

const useDetailContactHistoryEmailStore = createVersionedStorage<
  DetailContactHistoryEmailFilters,
  ApiSortsDerived<ApiContactHistoryEmail>,
  ContactHistoryEmail[]
>('detailContactHistoryEmail', {
  fetchFn: getDetailContactHistoryEmail,
  defaultData: [],
  defaultFilters: {},
  defaultSorts: [],
});

export default useDetailContactHistoryEmailStore;
